import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export default function TrendingNow() {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <title> My Subscription</title>
            </Helmet>

            {/* start: trending-now */}
            <div className="main-body">
                <div className="main-header-s1 center-text">
                    <button type="button" className="back-btn" onClick={() => { navigate(-1) }}>
                        <img src="/images/icons/chevron-left.svg" alt="" />
                    </button>
                    <h1>Trending Now</h1>
                    <button type="button" className="transparent-btn">
                        <img src="/images/icons/info.svg" alt="" />
                    </button>
                </div>
                <div className="body-content">
                    <div className="my-subscribers-layout">
                        <div className="layout-item">
                            <div className="layout-box widget-type2">
                                <div className="widget-header">
                                    <h2>Current topic trends</h2>
                                    <h4>Most discussed topics from the past week</h4>
                                </div>
                                {/* <div className="coming-soon-wrap" style={{ width: '100%' }}>
                                    <div className="blur-content" > */}
                                <div className="widget-body">
                                    <div className="trending-now-lists">
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Love</h3>
                                                    <div
                                                        className="counter"
                                                        style={{
                                                            background:
                                                                "linear-gradient(180deg, #FF4DA6 0%, #EB3992 100%)"
                                                        }}
                                                    >
                                                        1
                                                    </div>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">2,480 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">12,480 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Relationships</h3>
                                                    <div
                                                        className="counter"
                                                        style={{
                                                            background:
                                                                "linear-gradient(180deg, #4B73EB 0%, #375FD7 100%)"
                                                        }}
                                                    >
                                                        2
                                                    </div>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">2,120 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">10,265 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Mindfulness</h3>
                                                    <div
                                                        className="counter"
                                                        style={{
                                                            background:
                                                                "linear-gradient(180deg, #BB4DFF 0%, #A739EB 100%)"
                                                        }}
                                                    >
                                                        3
                                                    </div>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,980 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">9,320 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Trump</h3>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,720 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">8,430 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Confidence</h3>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,650 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">8,210 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>AI &amp; Emotions</h3>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,540 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">7,890 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Tariffs</h3>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,460 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">6,975 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="trending-now-item">
                                            <div className="trending-now-box">
                                                <div className="title-with-counter">
                                                    <h3>Climate Anxiety</h3>
                                                </div>
                                                <ul className="text-with-icon-lists">
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">1,310 Conversations</span>
                                                    </li>
                                                    <li>
                                                        <span className="icon">
                                                            <img src="/images/icons/messages.svg" alt="" />
                                                        </span>
                                                        <span className="text">6,480 messages</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* </div>
                                    <div className="coming-soon-badge">Coming Soon</div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="bottom-cpx-text">Metrics update every 24 hours.</div> */}
            </div>

            {/* end: trending-now */}
        </>
    );
}

